import React, { FC } from 'react';

export const TestResultsIcon: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="none">
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M8.343 66.759a.982.982 0 0 0 1.357.367L45.503 46.29a1 1 0 0 0 .497-.864L46.002 4a.982.982 0 0 0-1-.989A43 43 0 0 0 8.342 66.76Zm2.116-4.703L42 43.7l.001-36.495A39 39 0 0 0 10.46 62.057ZM81 70V58a2 2 0 0 0-2-2H67a2 2 0 0 0-2 2v8H55a2 2 0 0 0-2 2v23a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V72a2 2 0 0 0-2-2H81ZM69 60v29h8V60h-8Zm12 14v15h8V74h-8Zm-24-4h8v19h-8V70Zm-3-22.575V11.217a36.999 36.999 0 0 1 31.127 48.406c-.083.25-.127.512-.127.776 0 2.448 2.876 3.117 3.663.798 1.472-4.336 2.343-8.936 2.337-13.251A41.001 41.001 0 0 0 51 7.012.981.981 0 0 0 50 8v39.425a1 1 0 0 1-.497.864L15.43 68.122a.981.981 0 0 0-.35 1.362 41 41 0 0 0 31.87 19.403c1.123.083 2.05-.826 2.05-1.951 0-1.085-.865-1.967-1.946-2.053A37.001 37.001 0 0 1 20.222 69.96l31.293-18.215A5 5 0 0 0 54 47.426ZM35.567 12.581C21.332 17.021 11 30.304 11 46c0 2.772.322 5.468.931 8.054.294 1.247 1.713 1.8 2.823 1.16l.053-.03c.792-.458 1.166-1.393.964-2.284A31.098 31.098 0 0 1 15 46c0-13.816 9.038-25.521 21.525-29.525.863-.277 1.475-1.064 1.475-1.97v-.065c0-1.288-1.203-2.242-2.433-1.859Z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient id="a" x1="48" x2="48" y1="3.011" y2="93" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00B4D5" />
          <stop offset="1" stopColor="#AEC3FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
